import React from 'react';
import CancelBookingButton from './CancelBookingButton'
import RemoveEntryButton from './RemoveEntryButton';
import { getBookingCategoryLabel, supportsBrandedFare } from '../../../globalFunctions/bookingCategory';

interface CreatedBookingItemProps {
  reference: string;
  cancelled: boolean;
  productClass?: string | null;
  bookingCategory?: string;
  onCancelBooking: Function;
  onRemoveEntry: Function;
}

const CreatedBookingItem : React.FC<CreatedBookingItemProps> = ({reference, cancelled, productClass, bookingCategory, onCancelBooking, onRemoveEntry}) => {
  const capitalize = (str?: string | null) => str ? str.charAt(0).toUpperCase() + str.slice(1) : '';
  const brandedFareText = supportsBrandedFare(bookingCategory)
    ? capitalize(productClass)
    : '';
  const details = [getBookingCategoryLabel(bookingCategory), brandedFareText].filter(Boolean).join(' · ');
  
  return (
    <li data-testid="created-booking" className={`bg-gray-100 p-2 rounded-md mb-2 flex justify-between items-center`}>
      <div className={`${cancelled ? 'line-through' : ''}`}>
        <div className="font-medium">{reference}</div>
        {details && <div className="text-xs text-gray-500 whitespace-nowrap">{details}</div>}
      </div>
      {
        cancelled ?
        <RemoveEntryButton bookingReference={reference} onRemoveEntry={onRemoveEntry} /> :
        <CancelBookingButton bookingReference={reference} cancelled={cancelled} onCancelBooking={onCancelBooking} />
      }
    </li>
  );
};

export default CreatedBookingItem;
